import { asLeafKey, asPlantId, isAdminGrant } from '../types';
import type { MeAccess } from '../types';

import type { MePayload } from './schemas';

export const normalizeMe = (payload: MePayload): MeAccess => ({
  adminGrant: payload.adminGrant !== null && isAdminGrant(payload.adminGrant) ? payload.adminGrant : null,
  adminKeys: new Set(payload.adminKeys.map(asLeafKey)),
  plantIds: payload.plantIds.map(asPlantId),
});
